import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'

const PFStatusUpdateModalUI = ({
    context, successMsg, errorList, setErrorList,
    updateMode, submitted, onSubmit, onCancelClick,
    processingFeeStatus, onProcessingFeeStatusChange, processingFeeStatusList,
    tdsAmount, onTdsAmountChange,
    waivePercentage, onwaivePercentageChange
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Processing fee status update'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputSelectSF
            type='select'
            name='processingFeeStatus'
            label='Processing fee status'
            value={processingFeeStatus}
            onChange={onProcessingFeeStatusChange}
            optionList={processingFeeStatusList}
            setError={() => { }}
        />

        <InputTextSF
            type='text'
            name='waivePercentage'
            label='Waive Percentage (%)'
            value={waivePercentage}
            onChange={onwaivePercentageChange}
            setError={() => { }}
        />

        <InputTextSF
            type='text'
            name='tdsAmount'
            label='TDS amount'
            maxLength={10}
            value={tdsAmount}
            onChange={onTdsAmountChange}
            setError={() => { }}
        />

    </ModalFormUI>

export default PFStatusUpdateModalUI